import Section from "../components/wida/Section";

export default function NotFound() {
    return <>
        <Section>
            <div className="text-center">
                <h1 className="glitch text-9xl font-bold tracking-widest" data-text="404">
                    404
                </h1>
                <p className="text-3xl font-normal mt-2">
                    This page does not exist
                </p>
                <a href="/">Return to homepage</a>
            </div>
        </Section>
    </>
}